/**
 * Bike status enum
 */
export enum BikeStatus {
  AVAILABLE = 'available',
  RENTED = 'rented',
  MAINTENANCE = 'maintenance',
  RESERVED = 'reserved',
  UNAVAILABLE = 'unavailable',
}

/**
 * Bike type enum
 */
export enum BikeType {
  CITY = 'city',
  MOUNTAIN = 'mountain',
  ROAD = 'road',
  FOLDING = 'folding',
  CRUISER = 'cruiser',
}

/**
 * Bike interface matching Firestore schema
 */
export interface Bike {
  id: string;
  name: string;
  description: string;
  type: BikeType;
  status: BikeStatus;
  locationId: string;
  halfDayRate: number; // in cents (4-6 hours)
  fullDayRate: number; // in cents (24 hours)
  // Extended rental discounts (in percentage, e.g., 10 = 10% off)
  twoDayDiscount?: number; // discount for 2-day rental
  threeDayDiscount?: number; // discount for 3-day rental
  weekDiscount?: number; // discount for 7-day rental
  batteryLevel?: number; // 0-100
  mileage?: number; // in km
  imageUrls: string[];
  specifications?: {
    maxSpeed?: number; // km/h
    range?: number; // km
    weight?: number; // kg
    maxLoad?: number; // kg
  };
  createdAt: Date;
  updatedAt: Date;
}

/**
 * Location interface matching Firestore schema
 */
export interface Location {
  id: string;
  name: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  coordinates: {
    latitude: number;
    longitude: number;
  };
  phoneNumber?: string;
  email?: string;
  hours?: {
    [key: string]: { open: string; close: string }; // e.g., "monday": { open: "09:00", close: "17:00" }
  };
  amenities?: string[];
  imageUrls: string[];
  partnerId: string;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
}

